import './AccordionHeader.scss';

import React from 'react';

function AccordionHeader({ expanded, alwaysOpen, title, toggle, children }) {
  return (
    <div className="accordion-header">
      {!alwaysOpen && (
        <button className="fold-trigger" onClick={toggle}>
          <span
            className={`arrow ${
              expanded ? 'aa-chevron-up' : 'aa-chevron-down'
            }`}
          />
          {title}
        </button>
      )}
      {alwaysOpen && <div>{title}</div>}
      {children}
    </div>
  );
}

export default AccordionHeader;
